<p-messages [(value)]="msgs"></p-messages>
<div class="p-grid">
    <div class="col-12 p-md-12 p-lg-12" *ngIf="cargandoDataInit">
        <div class="card">
            <h4>{{appConfig.ux.loadingMsg}}</h4>
            <p-progressBar mode="indeterminate"></p-progressBar> 
        </div>
    </div>
    <div class="col-12 p-md-12 p-lg-12" *ngIf="!cargandoDataInit">
        <div class="card">
            <p-treeTable #tt [value]="catalogosTree" [columns]="cols"
                         selectionMode="checkbox" [(selection)]="catalogosTreeNodosSeleccionados"
                         [rowHover]="true" 
                         rows="{{appConfig.ux.treeTableRows}}" 
                         paginator="{{appConfig.ux.treeTablePaginator}}" 
                         rowsPerPageOptions="{{appConfig.ux.treeTableRowsPerPageOptions}}" 
                         [scrollable]="false" [responsive]='true'
                         [filterDelay]="0" [globalFilterFields]="['nombre', 'descripcion']"
                         sortMode="multiple" [multiSortMeta]="multiSortMeta"
                         styleClass="p-treetable-striped p-treetable-sm">
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between table-header">
                        <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-start table-header">
                            <button pButton type="button" 
                                    label="{{appConfig.ux.actions.create}}" 
                                    icon="pi pi-plus"
                                    (click)="nuevoCatalogo();"
                                    [disabled]="!puedeEjecutar('crear')">
                            </button>
                            <button pButton pRipple type="button"
                                    pTooltip="Borrar seleccionadas" tooltipPosition="bottom"
                                    icon="pi pi-trash" class="p-button-help p-ml-1"
                                    (click)="confirmarBorrarSeleccionados();" 
                                    [disabled]="!puedeEjecutar('borrado') 
                                    || !(catalogosTreeNodosSeleccionados && catalogosTreeNodosSeleccionados.length)">
                            </button>
                        </div>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="tt.filterGlobal($event.target.value, 'contains')"
                                   placeholder="Buscar.."/>
                        </span>
                    </div>
                    <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-start p-mt-2 table-header">
                        <p-treeTableHeaderCheckbox></p-treeTableHeaderCheckbox>
                        <span style="margin-left: .25em; vertical-align: middle">Seleccionar todo</span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" [ttSortableColumn]="col.field"  [hidden]="!col.visible">
                            {{col.header}}<p-treeTableSortIcon [field]="col.field"></p-treeTableSortIcon>
                    </th>
                    <th style="width: 12rem"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
                    <tr>
                        <td *ngFor="let col of columns; let i = index" [hidden]="!col.visible">
                    <p-treeTableToggler [rowNode]="rowNode" *ngIf="i == 0"></p-treeTableToggler>
                    <p-treeTableCheckbox [value]="rowNode" *ngIf="i == 0"></p-treeTableCheckbox>
                    {{col.field != 'fecha' ? rowData[col.field] : (rowData[col.field] | date: 'yyyy/MM/dd HH:mm:ss')}}
                    </td>
                    <td style="width: 12rem">
                        <button pButton pRipple type="button"
                                pTooltip="{{appConfig.ux.actions.add}}" tooltipPosition="bottom" 
                                icon="pi pi-plus" class="p-button-rounded" 
                                (click)="agregarCatalogo(rowData);"
                                [disabled]="!puedeEjecutar('crear')">
                        </button>
                        <button pButton pRipple type="button" 
                                pTooltip="{{appConfig.ux.actions.edit}}" tooltipPosition="bottom" 
                                icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-plain"
                                (click)="editarCatalogo(rowData);"
                                [disabled]="!puedeEjecutar('escritura')">
                        </button>
                        <button pButton type="button" 
                                pTooltip="{{appConfig.ux.actions.delete}}" tooltipPosition="bottom" 
                                icon="pi pi-trash" class="p-button-rounded p-button-text p-button-secondary"
                                (click)="confirmarBorrarCatalogo(rowNode);"
                                [disabled]="!puedeEjecutar('borrado')">
                        </button>
                    </td> 
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr><td [attr.colspan]="columns.length">{{appConfig.ux.emptyMsg}}</td></tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <button pButton type="button" 
                            pTooltip="{{appConfig.ux.actions.refresh}}" tooltipPosition="bottom" 
                            icon="pi pi-refresh" class="p-button-rounded p-button-text"
                            (click)="tt.reset();">
                    </button>
                </ng-template>
            </p-treeTable>
        </div>
    </div>
</div>
<!--------------------------------------->
<!------Diálogos de funcionalidades------>
<!--------------------------------------->
<!-- Diálogos de creación/edición de catalogo -->
<p-dialog [header]="(catalogo && catalogo.id) ? 'Editar Catalogo' : 'Nuevo Catalogo'" 
          [(visible)]="mostrarEditor && catalogo" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '75vw'}"
          (onHide)="mostrarEditor=false;">
    <form #catalogoEditorForm="ngForm"
          (ngSubmit)="guardarCatalogo();"
          [ngClass]="{'disabledForm': false}"><!--catalogoEditorForm.reset();-->
        <p-messages [(value)]="msgs"></p-messages>
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field col-12">
                <h2 class="p-text-uppercase">{{catalogo.name}}</h2>
            </div>
            <div class="p-field col-12">
                <label for="grupo">Grupo</label>
                <p-autoComplete inputId="grupo" name="grupo"   
                                [(ngModel)]="grupo" 
                                [suggestions]="catalogosFiltrados" [itemSize]="34"
                                (completeMethod)="filtrarCatalogos($event)" field="nombre"
                                placeholder="Buscar por nombre..."
                                [showEmptyMessage]="true" emptyMessage="{{appConfig.ux.emptyMsg}}"
                                [minLength]="3" [dropdown]="true" 
                                [forceSelection]="true"
                                [virtualScroll]="true">
                </p-autoComplete>
            </div>
            <div class="p-field col-12 p-md-6">
                <label for="codigo">Código</label>
                <input #codigo="ngModel" id="codigo" name="codigo" type="text" 
                       [(ngModel)]="catalogo.code"
                       [disabled]="(catalogo && catalogo.id)"
                       [pattern]="appConfig['validationRegExp']['codigoPattern']"
                       required pInputText>
                <p-message severity="error" [text]="appConfig['validationMsgs']['codigoPattern']" 
                           *ngIf="catalogoEditorForm.controls['codigo']
                           && !catalogoEditorForm.controls['codigo'].valid 
                           && (catalogoEditorForm.controls['codigo'].dirty 
                           || catalogoEditorForm.controls['codigo'].touched)">
                </p-message>
            </div>
            <div class="p-field col-12 p-md-6">
                <label for="nombre">Nombre</label>
                <input #nombre="ngModel" id="nombre" name="nombre" type="text" 
                       [(ngModel)]="catalogo.name" 
                       [pattern]="appConfig['validationRegExp']['safeTextPattern']"
                       required pInputText>
                <p-message severity="error" [text]="appConfig['validationMsgs']['safeTextPattern']" 
                           *ngIf="catalogoEditorForm.controls['nombre']
                           && !catalogoEditorForm.controls['nombre'].valid 
                           && (catalogoEditorForm.controls['nombre'].dirty 
                           || catalogoEditorForm.controls['nombre'].touched)">
                </p-message>
            </div>
            <div class="p-field col-12">
                <label for="datoDefecto">Valor/Dato por defecto</label>
                <textarea #datoDefecto="ngModel" id="datoDefecto" name="datoDefecto" type="text"
                          [(ngModel)]="catalogo.datoDefecto" 
                          [pattern]="appConfig['validationRegExp']['safeMultilineTextPattern']"
                          [rows]="5"
                          pInputTextarea></textarea>
                <p-message severity="error" [text]="appConfig['validationMsgs']['safeMultilineTextPattern']" 
                           *ngIf="catalogoEditorForm.controls['datoDefecto'] 
                           && !catalogoEditorForm.controls['datoDefecto'].valid 
                           && (catalogoEditorForm.controls['datoDefecto'].dirty 
                           || catalogoEditorForm.controls['datoDefecto'].touched)">
                </p-message>
            </div>
            <div class="p-field col-12">
                <label for="descripcion">Características del catálogo</label>
                <textarea #descripcion="ngModel" id="descripcion" name="descripcion" type="text"
                          [(ngModel)]="catalogo.description" 
                          [pattern]="appConfig['validationRegExp']['safeMultilineTextPattern']"
                          [rows]="5"
                          pInputTextarea></textarea>
                <p-message severity="error" [text]="appConfig['validationMsgs']['safeMultilineTextPattern']" 
                           *ngIf="catalogoEditorForm.controls['descripcion'] 
                           && !catalogoEditorForm.controls['descripcion'].valid 
                           && (catalogoEditorForm.controls['descripcion'].dirty 
                           || catalogoEditorForm.controls['descripcion'].touched)">
                </p-message>
            </div>
        </div>
        <p-footer>
            <div class="p-d-flex p-flex-lg-row p-flex-column p-jc-end">
                <button pButton type="button" 
                        label="{{appConfig.ux.actions.cancel}}"
                        icon="pi pi-times" class="p-button-secondary"
                        (click)="mostrarEditor=false;">
                </button>
                <button pButton type="submit" 
                        label="{{appConfig.ux.actions.save}}"
                        icon="pi pi-check" class="p-ml-lg-1"
                        [disabled]="(!catalogoEditorForm.valid)">
                </button>
            </div>
        </p-footer>
    </form>
</p-dialog>
<!---------------------------------------------->
<!------Ventanas de confirmaciones modales------>
<!---------------------------------------------->
<p-confirmDialog #cd header="Confirmación" icon="pi pi-exclamation-triangle">
    <ng-template pTemplate="footer">
        <button pButton type="button" 
                label="No"
                icon="pi pi-times" class="p-button-secondary"
                (click)="cd.reject()">
        </button>
        <button pButton type="button" 
                label="Sí"
                icon="pi pi-check" class="p-ml-2"
                (click)="cd.accept()">
        </button>
    </ng-template>
</p-confirmDialog>